/**
 * Foundation/Anagrafica — P-UX-06: proposta Provincia (e CAP se unico) dal Comune.
 * Nessuna compilazione automatica: l'operatore conferma con un clic.
 */
import React, { useEffect, useState } from "react";
import { CornerDownRight, Info } from "lucide-react";
import { findComuni } from "@/foundation/geo/api";

export const MULTI_CAP_MESSAGE = "Questo Comune dispone di più CAP. Inserire la via per determinare il CAP corretto.";

export function proposalFor(match, provincia, cap) {
  const singleCap = match.cap.length === 1 ? match.cap[0] : null;
  const setProv = (provincia || "") !== match.sigla;
  const setCap = !!singleCap && (cap || "") !== singleCap;
  if (!setProv && !setCap) return null;
  const parts = [setProv && `Provincia ${match.sigla}`, setCap && `CAP ${singleCap}`].filter(Boolean);
  return { label: `Usa ${parts.join(" e ")}`, values: { ...(setProv && { provincia: match.sigla }), ...(setCap && { cap: singleCap }) } };
}

export function ComuneAssist({ comune, provincia, cap, onApply, testIdPrefix = "comune-assist" }) {
  const [matches, setMatches] = useState([]);
  const query = (comune || "").trim();

  useEffect(() => {
    if (query.length < 2) { setMatches([]); return undefined; }
    let alive = true;
    const t = setTimeout(() => {
      findComuni(query, { exact: true }).then((m) => alive && setMatches(m)).catch(() => alive && setMatches([]));
    }, 300);
    return () => { alive = false; clearTimeout(t); };
  }, [query]);

  if (!matches.length) return null;
  const multiCap = matches.length === 1 && matches[0].cap.length > 1 && !cap;
  return (
    <div className="mt-1 space-y-0.5" data-testid={`${testIdPrefix}`}>
      {matches.map((m) => {
        const p = proposalFor(m, provincia, cap);
        if (!p) return null;
        return (
          <button key={m.istat} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onApply(p.values)}
            className="flex items-center gap-1 text-xs text-suite-primary underline-offset-2 hover:underline"
            data-testid={`${testIdPrefix}-apply-${m.sigla}`}>
            <CornerDownRight size={12} /> {p.label}{matches.length > 1 ? ` (${m.provincia})` : ""}
          </button>
        );
      })}
      {multiCap && (
        <div className="flex items-center gap-1 text-xs text-suite-neutral-500" data-testid={`${testIdPrefix}-multicap`}>
          <Info size={11} /> {MULTI_CAP_MESSAGE}
        </div>
      )}
    </div>
  );
}

export default ComuneAssist;
